import { ICcypair, ISO4217 } from '@alk/currency';
import { IPadConfig } from '../interfaces';
import { ITradePadBrandingConfig, SecuritySymbol, SYMBOL_TYPES } from '@fnx/fx-pad';
import { Tenor } from '@alk/dates';

//TODO: mock before it comes from server
//Contract PR draft:
//https://scm-git-eur.misys.global.ad/projects/FNX/repos/ofx-gateway-protocol/pull-requests/75/diff#messages/TradingSettings.proto
export const TRADE_PAD_DEFAULT_SETTINGS: ITradePadBrandingConfig = {
    forward: {
        displayMode: 'default',
    },
    productTypes: SYMBOL_TYPES,
    expiryTypes: [ 'gtc' ],
    pendingPriceTypes: [ 'limit', 'stop' ],
};

const EURUSD: SecuritySymbol = {
    symbol: 'EURUSD' as ICcypair,
    roundLot: 100,
    minimumTradeVolume: 1000,
    fractionSize: 5,
    extraDigitSupport: true,
    extraDigitSize: 2,
    settlementPeriodInDays: 2,
};

export const STATE_01: IPadConfig = {
    id: '123',
    productType: 'spot',
    instrument: EURUSD,
    tradedCurrency: 'EUR' as ISO4217,
    quantity: 0,
    spotType: 'full',
    pendingType: 'limit',
    date: 'SP' as Tenor,
    dateFar: '1Y' as Tenor,
};
